import { SavedFiltersFilterItem, savedFiltersKey } from "./types";

type StoreProps = {
    pageKey: string;
    pageTitle: string,
    viewName: string;
    filters: Record<string, SavedFiltersFilterItem>
}

export const storeFilters = ({ pageKey, pageTitle, viewName, filters }: StoreProps) => {
    const savedFilters = localStorage.getItem(savedFiltersKey) || '{}';
    const parsedFilters = JSON.parse(savedFilters);
    const pageInfo = parsedFilters[pageKey] || {};
    const filterViewId = `${viewName.split(' ').join('-').toLowerCase()}-${Date.now()}`
    const newFilters = {
        ...parsedFilters,
        [pageKey]: {
            pageTitle,
            filterViews: {
                ...pageInfo.filterViews ?? {},
                [filterViewId]: {
                    id: filterViewId,
                    name: viewName,
                    createdAt: new Date().toISOString(),
                    filters,
                }
            }
        },
    }

    localStorage.setItem(savedFiltersKey, JSON.stringify(newFilters));
}